import Vue from 'vue';
import Component from 'vue-class-component';

import template from './Pointer.vue.html';
@Component({ template, props: ['total', 'current'] })
export default class Pointer extends Vue {
    total!: number;
    current!: number;

    getPosition() {
        if (this.total < 2) return `translate(${350 / 2} 0)`;
        const cx = ((this.current - 1) * 350) / (this.total - 1);
        return `translate(${cx} 0)`;
    }

    getPoint(step: number) {
        if (this.total < 2) return 350 / 2;
        return ((step - 1) * 350) / (this.total - 1);
    }

    paddingNum(num: number) {
        return ('0' + num).substr(-2);
    }
}
